<div *ngIf="!textonly" class="ui-g-12" style="min-height: 30px">
    <a class="dimension-picker" (click)="displayTable = true"
        >{{ this.buttonText }}: <strong *ngIf="this.selectedDimensionValue">{{ this.selectedDimensionValue.data.name }}</strong></a
    >
    <button
        *ngIf="this.selectedDimensionValue"
        class="p-button-info"
        style="margin-left: 6px"
        pButton
        (click)="selectedDimensionValue = null;this.changeAllocationItemId(null)"
        icon="ui-icon-clear"
    ></button>
    <button
        *ngIf="!this.selectedDimensionValue"
        class="p-button-info"
        pButton
        (click)="displayTable = true"
        icon="ui-icon-touch-app"
    ></button>
</div>
<div *ngIf="textonly">
    <a class="dimension-picker" (click)="displayTable = true">
        <strong *ngIf="!this.selectedDimensionValue">{{this.buttonText}}</strong>
        <strong *ngIf="this.selectedDimensionValue">{{ this.selectedDimensionValue.data.name }}</strong>
    </a>
</div>

<p-dialog
    header="All Report Lines"
    [(visible)]="displayTable"
    [style]="{width: '80%', align: 'center' }"
    appendTo="body"
    [resizable]="true"
    [maximizable]="true"
    [closeOnEscape]="true"
    (onHide)="closed()"
>
    <div class="ui-g">
        <div class="ui-g-12">
            <tree-table
                [inputTreeNodes]="linesForTable"
                [treeColumns]="tableColumns"
                [loadingTreeNodes]="loading"
                selectionMode="single"
                [(selected)]="selected"
                showLeafViewByDefault=true
            ></tree-table>
        </div>
    </div>
    <div class="ui-g">
        <div class="ui-g-12">
            <button
                label="OK"
                pButton
                icon="ui-icon-check"
                (click)="okClick()"
                style="margin-right: 0.5em"
            ></button>
            <button
                label="Cancel"
                pButton
                icon="ui-icon-cancel"
                (click)="displayTable = false"
            ></button>
        </div>
    </div>
</p-dialog>
